import React from 'react';
import './CorgeeWarning.css';

export interface CorgeeWarningProps {
  show?: boolean;
  warningText?: string;
  canClose?: boolean;
  id?: string;
  isDuplicateProject?: boolean;
}

const CorgeeWarning: React.FC<CorgeeWarningProps> = ({
  show = false,
  warningText,
  id,
  isDuplicateProject,
}) =>
{
  if (!show) return null;

  return (
    <div
      className={`${isDuplicateProject ? 'duplicate-project-warning-style' : 'react-corgee-warning'}`}
      id={id}
    >
      <p>{warningText}</p>
    </div>
  );
};

export default CorgeeWarning;
